import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Star } from "lucide-react";
import { FadeIn } from "./FadeIn";
import { REVIEWS } from "@/config/siteConfig";

// HARDCODED FILTER LAYER: only 4-star and 5-star reviews are ever rendered.
const PREMIUM_REVIEWS = REVIEWS.filter((r) => r.rating >= 4);

const Stars = ({ n }) => (
  <div className="flex gap-1">
    {[...Array(5)].map((_, i) => (
      <Star key={i} size={18} className={i < n ? "fill-[#D4AF37] text-[#D4AF37]" : "text-[#D4AF37]/25"} />
    ))}
  </div>
);

export const Testimonials = () => {
  const [idx, setIdx] = useState(0);

  useEffect(() => {
    const t = setInterval(() => setIdx((i) => (i + 1) % PREMIUM_REVIEWS.length), 5000);
    return () => clearInterval(t);
  }, []);

  const review = PREMIUM_REVIEWS[idx];

  return (
    <section id="testimonials" data-testid="testimonials-section" className="bg-[#043927] py-24 lg:py-32 relative overflow-hidden">
      <div className="max-w-4xl mx-auto px-6 lg:px-10 text-center">
        <FadeIn>
          <p className="text-[#D4AF37] uppercase tracking-[0.4em] text-xs mb-5">Voices of Celebration</p>
          <h2 className="font-serif-luxe text-4xl md:text-5xl font-medium text-[#FAF9F6] leading-tight">
            Client <span className="italic text-[#F3E5AB]">Testimonials</span>
          </h2>
        </FadeIn>

        <div className="mt-16 min-h-[280px] flex items-center justify-center">
          <AnimatePresence mode="wait">
            <motion.div
              key={idx}
              data-testid="testimonial-active-card"
              initial={{ opacity: 0, y: 24 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -24 }}
              transition={{ duration: 0.6 }}
              className="bg-[#FAF9F6]/[0.06] backdrop-blur-md border border-[#D4AF37]/25 rounded-sm px-8 md:px-14 py-12"
            >
              <div className="flex justify-center mb-6"><Stars n={review.rating} /></div>
              <p className="font-serif-luxe italic text-xl md:text-2xl text-[#FAF9F6]/90 leading-relaxed">"{review.text}"</p>
              <p className="mt-8 text-[#D4AF37] font-semibold tracking-wide">{review.name}</p>
              <p className="text-[#FAF9F6]/50 text-xs mt-1 uppercase tracking-[0.25em]">Google Review · {review.date}</p>
            </motion.div>
          </AnimatePresence>
        </div>

        <div className="mt-10 flex justify-center gap-3">
          {PREMIUM_REVIEWS.map((_, i) => (
            <button
              key={i}
              data-testid={`testimonial-dot-${i}`}
              onClick={() => setIdx(i)}
              className={`h-[3px] transition-[width,background-color] duration-500 ${idx === i ? "w-10 bg-[#D4AF37]" : "w-5 bg-white/30"}`}
              aria-label={`Review ${i + 1}`}
            />
          ))}
        </div>
      </div>
    </section>
  );
};
